import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./pages/Login";
import ProtectedRoute from "./components/guards/ProtectedRoute";
import NotFound from "./pages/NotFound";
import AdminLayout from "./components/layouts/AdminLayout";
import Users from "./pages/admin/UsersPage/UsersPage";
import NewUserPage from "./pages/admin/UsersPage/NewUserPage";
import EditUserPage from "./pages/admin/UsersPage/EditUserPage";
import MachinesPage from "./pages/admin/MachinesPage/MachinesPage";
import NewMachinePage from "./pages/admin/MachinesPage/NewMachinePage";
import EditMachinePage from "./pages/admin/MachinesPage/EditMachinePage";
import { selectUser } from "./features/auth/authSlice";
import Dashboard from "./pages/admin/Dashboard";

export default function App() {
  const user = useSelector(selectUser);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<AdminLayout />}>
          <Route path="" element={<Dashboard />} />
          <Route path="manage-users/:role" element={<Users />} />
          <Route path="manage-users/:role/new" element={<NewUserPage />} />
          <Route
            path="manage-users/:role/edit/:id"
            element={<EditUserPage />}
          />
          <Route path="machines" element={<MachinesPage />} />
          <Route path="machines/new" element={<NewMachinePage />} />
          <Route path="machines/edit/:id" element={<EditMachinePage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
